import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import { Badge, IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { useQuickChat } from '../../context/QuickChat'

interface QuickChatButtonProps {
  size?: 'small' | 'medium' | 'large'
  sx?: object
}

export const QuickChatButton: React.FC<QuickChatButtonProps> = ({ size = 'medium', sx }) => {
  const { totalUnreadCount, setDrawerOpen } = useQuickChat()

  return (
    <Tooltip title="Quick Chat">
      <IconButton
        size={size}
        onClick={() => setDrawerOpen(true)}
        sx={{
          minWidth: 50,
          minHeight: 50,
          transition: 'transform 0.2s ease-in-out',
          '& .MuiSvgIcon-root': {
            color: 'text.primary',
            transition: 'color 0.2s ease-in-out',
          },
          '&:hover': {
            backgroundColor: 'transparent',
            transform: 'scale(1.2)',
            '& .MuiSvgIcon-root': {
              color: 'rgb(100, 181, 246)', // Light blue for chat
            },
          },
          ...sx,
        }}
      >
        <Badge
          badgeContent={totalUnreadCount}
          color="error"
          max={99}
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.65rem',
              minWidth: 16,
              height: 16,
            },
          }}
        >
          <ChatBubbleOutlineIcon fontSize={size === 'small' ? 'small' : 'medium'} />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

export default QuickChatButton
